{
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "confirm": "Confirm"
  },
  "status": {
    "loading": "Loading…"
  },
  "nav": {
    "openMenu": "Open menu",
    "closeMenu": "Close menu",
    "menuTitle": "Menu"
  }
}
